import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DocViewerLoader = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
    </div>
  );
};
